/** Field catalog for LTL manifest templates (shared by editor + print preview). */
export const FIELD_GROUPS = [
  {
    group: 'Carrier / Shipment Information',
    fields: [
      { key: 'manifest_number', label: 'Manifest Number' },
      { key: 'shipment_date', label: 'Shipment Date' },
      { key: 'carrier_name', label: 'Carrier Name' },
      { key: 'carrier_scac', label: 'Carrier SCAC' },
      { key: 'pro_number', label: 'PRO Number' },
      { key: 'bol_number', label: 'Bill of Lading Number' },
      { key: 'trailer_number', label: 'Trailer Number' },
      { key: 'seal_number', label: 'Seal Number' },
      { key: 'driver_name', label: 'Driver Name' },
      { key: 'driver_phone', label: 'Driver Phone' },
      { key: 'pickup_type', label: 'Pickup Type' },
      { key: 'service_level', label: 'Service Level' },
      { key: 'freight_terms', label: 'Freight Terms' },
      { key: 'payment_terms', label: 'Payment Terms' },
    ],
  },
  {
    group: 'Shipper Information',
    fields: [
      { key: 'shipper_name', label: 'Shipper Name' },
      { key: 'shipper_address', label: 'Address' },
      { key: 'shipper_city_state_zip', label: 'City/State/ZIP' },
      { key: 'shipper_contact', label: 'Contact' },
      { key: 'shipper_phone', label: 'Phone' },
      { key: 'shipper_email', label: 'Email' },
    ],
  },
  {
    group: 'Consignee Information',
    fields: [
      { key: 'consignee_name', label: 'Consignee Name' },
      { key: 'consignee_address', label: 'Address' },
      { key: 'consignee_city_state_zip', label: 'City/State/ZIP' },
      { key: 'consignee_contact', label: 'Contact' },
      { key: 'consignee_phone', label: 'Phone' },
      { key: 'consignee_email', label: 'Email' },
    ],
  },
  {
    group: 'Third-Party Billing Information',
    fields: [
      { key: 'bill_to_name', label: 'Bill To' },
      { key: 'bill_to_address', label: 'Address' },
      { key: 'bill_to_city_state_zip', label: 'City/State/ZIP' },
      { key: 'bill_to_account', label: 'Account Number' },
      { key: 'bill_to_phone', label: 'Phone' },
    ],
  },
  {
    group: 'Freight Details',
    fields: [
      { key: 'freight_table', label: 'Freight Details Table (lines)' },
      { key: 'total_handling_units', label: 'Total Handling Units' },
      { key: 'total_pieces', label: 'Total Pieces' },
      { key: 'total_weight', label: 'Total Weight' },
      { key: 'total_cube', label: 'Total Cube' },
      { key: 'hazmat', label: 'Hazardous Materials' },
      { key: 'temp_controlled', label: 'Temperature Controlled' },
      { key: 'stackable', label: 'Stackable' },
      { key: 'liftgate_required', label: 'Liftgate Required' },
      { key: 'inside_delivery', label: 'Inside Delivery' },
    ],
  },
  {
    group: 'Pickup Information',
    fields: [
      { key: 'pickup_date', label: 'Pickup Date' },
      { key: 'pickup_window', label: 'Pickup Window' },
      { key: 'pickup_location_type', label: 'Pickup Location Type' },
      { key: 'dock_available', label: 'Dock Available' },
      { key: 'pickup_instructions', label: 'Special Pickup Instructions' },
    ],
  },
  {
    group: 'Delivery Information',
    fields: [
      { key: 'estimated_delivery_date', label: 'Estimated Delivery Date' },
      { key: 'delivery_window', label: 'Delivery Window' },
      { key: 'delivery_location_type', label: 'Delivery Location Type' },
      { key: 'appointment_required', label: 'Appointment Required' },
      { key: 'delivery_appointment_number', label: 'Delivery Appointment Number' },
      { key: 'delivery_instructions', label: 'Special Delivery Instructions' },
    ],
  },
  {
    group: 'Reference Numbers',
    fields: [{ key: 'reference_numbers', label: 'Reference Numbers Table' }],
  },
  {
    group: 'Accessorials',
    fields: [{ key: 'accessorials', label: 'Accessorials Table' }],
  },
  {
    group: 'Shipment Certification',
    fields: [
      { key: 'certification_text', label: 'Certification Text' },
      { key: 'shipper_signature', label: 'Shipper Signature Line' },
      { key: 'driver_signature', label: 'Driver Signature Line' },
    ],
  },
  {
    group: 'Carrier Use Only',
    fields: [{ key: 'carrier_use_only', label: 'Carrier Use Only Section' }],
  },
];

export const ALL_FIELD_KEYS = FIELD_GROUPS.flatMap((g) => g.fields.map((f) => f.key));

export function getFieldLabel(key) {
  for (const g of FIELD_GROUPS) {
    const f = g.fields.find((x) => x.key === key);
    if (f) return f.label;
  }
  return key;
}
